import { SelectItem } from '@amirsavand/ngx-input';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { FIREBASE_OPTIONS as FIREBASE_OPTIONS_TOKEN } from '@angular/fire/compat';
import { routes } from '@app/app.routes';
import { FIREBASE_OPTIONS, VERSION } from '@app/shared/consts';
import { Profile } from '@app/shared/interfaces/profile';
import { ProfileMember } from '@app/shared/interfaces/profile-member';
import { ApiService } from '@app/shared/services/api.service';
import { AuthService } from '@app/shared/services/auth.service';
import { TenantHttpInterceptorService } from '@app/shared/services/tenant-http-interceptor.service';
import { Capacitor } from '@capacitor/core';
import { environment } from '@environments/environment';
import { ConfigLabelPipe, extractUploadedFile, provideCommon } from '@SavandBros/savandbros-ngx-common';

export const appConfig: ApplicationConfig = {
  providers: [
    ...provideCommon({
      routes,
      environment,
      version: VERSION,
      pages: {
        user: {
          brand: 'Chat',
          languageSelector: false,
          dashboard: {
            title: $localize`Workspaces`,
            description: $localize`Select workspace to enter.`,
            getTenants: (profile: Profile): SelectItem[] =>
              profile.members.map(
                (item: ProfileMember): SelectItem => ({
                  id: item.tenant.id,
                  name: item.tenant.name,
                  icon: extractUploadedFile(item.tenant, 'logo', 'assets/shared/tenant.svg'),
                  extra: { is_active: item.tenant.is_active },
                }),
              ),
          },
        },
      },
      authService: AuthService,
      apiService: ApiService,
      editorConfig: {
        toolbar: {
          heading: false,
          codeBlock: true,
          anchor: true,
          emoji: true,
        },
        enterIsSend: true,
        useNgZone: Capacitor.isNativePlatform(),
      },
    }),
    { provide: FIREBASE_OPTIONS_TOKEN, useValue: FIREBASE_OPTIONS },
    { provide: HTTP_INTERCEPTORS, useClass: TenantHttpInterceptorService, multi: true },
    ConfigLabelPipe,
  ],
};
